// hosts.js — Client-Fassung von lib/hosts.js (Links zwischen Startseite, App, Betreiber-Bereich, Hilfe, Verwaltung).
// Konfiguration aus <html data-hosts>; fehlt sie, gilt der Pfad-Modus. Test: test/hosts-client.test.mjs.
const PREFIX = { main: '', app: '/app', partner: '/partner', help: '/help', admin: '/admin' };
const SUBS = ['app', 'partner', 'help', 'admin'];
const AREAS = ['main', ...SUBS];

export function readConfig(raw) {
  try {
    const c = JSON.parse(raw || '');
    if (c && c.hosts) return { on: !!c.on, hosts: c.hosts, scheme: c.origin.scheme, port: c.origin.port || '' };
  } catch { /* Pfad-Modus */ }
  return { on: false, hosts: { main: '', app: '', partner: '', help: '', admin: '' }, scheme: 'https', port: '' };
}

const norm = (path) => (!path ? '/' : path.startsWith('/') ? path : '/' + path);

export function baseOf(cfg, area) { return cfg.on ? '' : PREFIX[area]; }

export function urlOf(cfg, area, path = '/', opts = {}) {
  const p = norm(path);
  if (!cfg.on) return PREFIX[area] + p;
  if (opts.from === area) return p;
  return cfg.scheme + '://' + cfg.hosts[area] + cfg.port + p;
}

export function areaOfLoc(cfg, hostname, pathname = '/') {
  if (cfg.on) {
    const h = String(hostname || '').toLowerCase();
    for (const a of SUBS) if (h === cfg.hosts[a]) return a;
    return 'main';
  }
  for (const a of SUBS) if (pathname === PREFIX[a] || pathname.startsWith(PREFIX[a] + '/')) return a;
  return 'main';
}

const OK_PATH = /^\/(?:(?:app|partner|help|admin)(?:[/?#][^\s\\]*)?)?$/;
const CLEAN = /^[^\s\\]*$/;

export function safeNextOf(cfg, raw) {
  const s = String(raw == null ? '' : raw).trim();
  if (!s || !CLEAN.test(s)) return null;
  if (s.startsWith('/')) {
    if (s.startsWith('//')) return null;
    if (cfg.on) return /^\/(?:[\w\-./%]*)(?:[?#][^\s\\]*)?$/.test(s) && !/^\/(?:api|auth)(?:[/?#]|$)/.test(s) ? s : null;
    return OK_PATH.test(s) ? s : null;
  }
  if (!cfg.on) return null;
  let u;
  try { u = new URL(s); } catch { return null; }
  if (u.protocol !== cfg.scheme + ':' || u.username || u.password) return null;
  return AREAS.some((a) => u.host === cfg.hosts[a] + cfg.port) ? s : null;
}

// Laufzeit-Konfiguration der Seite
export const HOSTS = readConfig(typeof document !== 'undefined' ? document.documentElement.dataset.hosts : '');
export const HERE = typeof location !== 'undefined' ? areaOfLoc(HOSTS, location.hostname, location.pathname) : 'main';
/** Link auf einen Bereich, relativ wenn möglich. */
export const url = (area, path) => urlOf(HOSTS, area, path, { from: HERE });
export const safeNext = (raw) => safeNextOf(HOSTS, raw);

/** Absolute Adresse (für Dateien, die außerhalb der Seite geöffnet werden, z. B. der Trip-Export). */
export const absUrl = (area, path) => { const u = urlOf(HOSTS, area, path); return /^https?:/.test(u) ? u : location.origin + u; };
/** Domain-Teil für Cookies, die über alle Subdomains gelten (Host-Modus), sonst leer. */
export const cookieDomain = () => (HOSTS.on ? '; domain=.' + HOSTS.hosts.main : '');
/** Anmeldung mit Rücksprung auf die aktuelle Seite (Host-Modus: absolute Adresse, weil die Anmeldung auf app. liegt). */
export const loginHref = () => urlOf(HOSTS, 'app', '/login', { from: HERE }) + '?next=' + encodeURIComponent(HOSTS.on ? location.href : location.pathname + location.search);
